export default __webpack_public_path__ + "static/media/tour-1.4118c3f4.png";